import { ACCOUNT_MANAGER_GROUP_VIDEO_REPORT_ID } from './account-manager-group-video/accountManagerGroupVideoReportId';
import { ACCOUNT_MANAGER_GROUP_REPORT_ID } from './account-manager-group/accountManagerGroupReportId';
import { ACCOUNT_MANAGER_VIDEO_REPORT_ID } from './account-manager-video/accountManagerVideoReportId';
import { ACCOUNT_MANAGER_REPORT_ID } from './account-manager/accountManagerReportId';
import { ACCOUNT_VIDEO_REPORT_ID } from './account-video/accountVideoReportId';
import { ACCOUNT_REPORT_ID } from './account/accountReportId';
import { ACTIVE_EVENTS_REPORT_ID } from './active-events/activeEventsReportId';
import { ADVERTISER_DOMAIN_REPORT_ID } from './advertiser-domain/advertiserDomainName';
import { ATTRIBUTION_GROUP_REPORT_ID } from './attribution-group/attributionGroupReportId';
import { AUDIENCE_BUNDLES_INSIGHTS_REPORT_ID } from './audience-bundles-insights/audienceBundlesInsightsReportId';
import { AUDIENCE_BUNDLES_REPORT_ID } from './audience-bundles/audienceBundlesReportId';
import { AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID } from './audience-insights-demographics/audienceInsightsDemographicsReportId';
import { AUDIENCE_INSIGHTS_REPORT_ID } from './audience-insights/audineceInsightsReportId';
import { AUDIENCE_REPORT_ID } from './audience/audienceReportId';
import { BROWSER_VIDEO_REPORT_ID } from './browser-video/browserVideoReportId';
import { BROWSER_REPORT_ID } from './browser/browserReportId';
import { CAMPAIGN_HISTORY_REPORT_ID } from './campaign-history/campaignHistoryReportId';
import { CAMPAIGN_REALTIME_REPORT_ID } from './campaign-realtime/campaignRealtimeReportId';
import { CAMPAIGN_VIDEO_REPORT_ID } from './campaign-video/campaignVideoReportId';
import { CAMPAIGN_REPORT_ID } from './campaign/campaignReportId';
import { CAMPAIGNS_GROUPS_REALTIME_REPORT_ID } from './campaigns-groups-realtime/campaignGroupRealtimeReportId';
import { CAMPAIGNS_GROUPS_REPORT_ID } from './campaigns-groups/campaignGroupReportId';
import { CITY_VIDEO_REPORT_ID } from './city-video/cityVideoReportId';
import { COMBINED_AUDIENCES_REPORT_ID } from './combined-audience/combinedAudiencesReportId';
import { CONTEXTUAL_INSIGHTS_REPORT_ID } from './contextual-insights/contextualInsightsReportId';
import { CONTEXTUAL_VIDEO_REPORT_ID } from './contextual-video/contextualVideoReportId';
import { CONTEXTUAL_REPORT_ID } from './contextual/contextualReportId';
import { CONVERSIONS_REPORT_ID } from './conversions/conversionsReportId';
import { COUNTRY_REALTIME_REPORT_ID } from './country-realtime/countryRealtimeReportId';
import { COUNTRY_VIDEO_REPORT_ID } from './country-video/countryVideoReportId';
import { COUNTRY_REPORT_ID } from './country/countryReportId';
import { CREATIVE_LIBRARY_REPORT_ID } from './creative-library/creativeLibraryReportId';
import { CREATIVE_REALTIME_REPORT_ID } from './creative-realtime/creativeRealtimeReportId';
import { DCO_CAMPAIGN_CREATIVE_REPORT_ID } from './creative-template-dco/dcoCampaignCreativeReportId';
import { CREATIVE_VIDEO_REPORT_ID } from './creative-video/creativeVideoReportId';
import { CREATIVE_REPORT_ID } from './creative/creativeReportId';
import { CUSTOM_CONTEXTUAL_REPORT_ID } from './custom-contextual/customContextualReportId';
import { DAY_OF_WEEK_VIDEO_REPORT_ID } from './day-of-week-video/dayWeekVideoReportId';
import { DAY_OF_WEEK_REPORT_ID } from './day-of-week/dayWeekReportId';
import { DAY_VIDEO_REPORT_ID } from './day-video/dayVideoReportId';
import { DAY_REPORT_ID } from './day/dayReportId';
import { DMA_VIDEO_REPORT_ID } from './dma-video/dmaVideoReportId';
import { DMA_REPORT_ID } from './dma/dmaReportId';
import { DYNAMIC_REPORTS_REPORT_ID } from './dynamic-reports/dynamicReportsReportId';
import { FIRST_PARTY_REPORT_ID } from './first-party/firstPartyReportId';
import { FUNNELS_REPORT_ID } from './funnels/funnelsReportId';
import { HIERARCHY_CAMPAIGN_REPORT_ID } from './hierarchy-campaign/hierarchyCampaignReportId';
import { HOUR_OF_DAY_VIDEO_REPORT_ID } from './hour-of-day-video/hourDayVideoReportId';
import { HOUR_OF_DAY_REPORT_ID } from './hour-of-day/hourDayReportId';
import { INVOICES_REPORT_ID } from './invoices/invoicesReportId';
import { DCO_ITEM_PERFORMANCE_REPORT_ID } from './item-dco/dcoItemPerformanceReportId';
import { LANDING_PAGES_REPORT_ID } from './landing-pages/landingPagesReportId';
import { PREDICTIVE_REPORT_ID } from './lookalike/predictiveReportId';
import { MONTH_VIDEO_REPORT_ID } from './month-video/monthVideoReportId';
import { MONTH_REPORT_ID } from './month/monthReportId';
import { OS_FAMILY_VIDEO_REPORT_ID } from './os-family-video/osFamilyVideoReportId';
import { OS_FAMILY_REPORT_ID } from './os-family/osFamilyReportId';
import { OS_VERSION_VIDEO_REPORT_ID } from './os-version-video/osVersionVideoReportId';
import { OS_VERSION_REPORT_ID } from './os-version/osVersionReportId';
import { PAYMENTS_REPORT_ID } from './payments/paymentsReportId';
import { PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID } from './performance-rule-executed-actions/preformanceRuleActionsReportId';
import { PERFORMANCE_RULES_REPORT_ID } from './performance-rules/performanceRulesReportId';
import { PIXEL_BASED_REPORT_ID } from './pixel-based/pixelBasedReportId';
import { PLATFORM_REALTIME_REPORT_ID } from './platform-realtime/platformRealtimeReportId';
import { PLATFORM_VIDEO_REPORT_ID } from './platform-video/platformVideoReportId';
import { PLATFORM_REPORT_ID } from './platform/platformReportId';
import { PUSH_API_REPORT_ID } from './push-api/pushApiReportId';
import { QUARTILE_VIDEO_REPORT_ID } from './quartile-video/quartileVideoReportId';
import { REGION_REPORT_ID } from './region/regionReportId';
import { SALES_GROUP_VIDEO_REPORT_ID } from './sales-group-video/salesGroupVideoReportId';
import { SALES_GROUP_REPORT_ID } from './sales-group/salesGroupReportId';
import { SALES_PERSON_VIDEO_REPORT_ID } from './sales-person-video/salesPersonVideoReportId';
import { SALES_PERSON_REPORT_ID } from './sales-person/salesPersonReportId';
import { SCHEDULED_REPORTS_REPORT_ID } from './scheduled-reports/scheduledReportsReportId';
import { SITE_REALTIME_REPORT_ID } from './site-realtime/siteRealtimeReportId';
import { SITE_VIDEO_REPORT_ID } from './site-video/siteVideoReportId';
import { SITE_REPORT_ID } from './site/siteReportId';
import { TEST_EVENTS_REPORT_ID } from './test-events/testEventsReportId';
import { TODAY_REPORT_ID } from './today/todayReportId';
import { WEEK_VIDEO_REPORT_ID } from './week-video/weekVideoReportId';
import { WEEK_REPORT_ID } from './week/weekReportId';

const REPORT_GROUP_TYPE = {
    TIME: 'time-group',
    GEO: 'geo-group',
    PLATFORM: 'platform-group',
    REP: 'rep-group',
    AM: 'am-group',
    CAMPAIGN: 'campaign-group',
    AD: 'ads',
};

const reportsGroupConfig = {
    [REPORT_GROUP_TYPE.TIME]: {
        label: 'Day',
        id: REPORT_GROUP_TYPE.TIME,
        options: [
            DAY_REPORT_ID,
            DAY_VIDEO_REPORT_ID,
            WEEK_REPORT_ID,
            WEEK_VIDEO_REPORT_ID,
            MONTH_REPORT_ID,
            MONTH_VIDEO_REPORT_ID,
            DAY_OF_WEEK_REPORT_ID,
            DAY_OF_WEEK_VIDEO_REPORT_ID,
            HOUR_OF_DAY_REPORT_ID,
            HOUR_OF_DAY_VIDEO_REPORT_ID,
        ],
    },
    [REPORT_GROUP_TYPE.GEO]: {
        label: 'Country',
        id: REPORT_GROUP_TYPE.GEO,
        options: [
            COUNTRY_REPORT_ID,
            COUNTRY_VIDEO_REPORT_ID,
            COUNTRY_REALTIME_REPORT_ID,
            CITY_VIDEO_REPORT_ID,
            REGION_REPORT_ID,
            DMA_REPORT_ID,
            DMA_VIDEO_REPORT_ID,
        ],
    },
    [REPORT_GROUP_TYPE.PLATFORM]: {
        label: 'Platforms',
        id: REPORT_GROUP_TYPE.PLATFORM,
        options: [
            PLATFORM_REPORT_ID,
            PLATFORM_VIDEO_REPORT_ID,
            PLATFORM_REALTIME_REPORT_ID,
            OS_FAMILY_REPORT_ID,
            OS_FAMILY_VIDEO_REPORT_ID,
            OS_VERSION_REPORT_ID,
            OS_VERSION_VIDEO_REPORT_ID,
            BROWSER_REPORT_ID,
            BROWSER_VIDEO_REPORT_ID,
        ],
    },
    [REPORT_GROUP_TYPE.AM]: {
        label: 'AM',
        id: REPORT_GROUP_TYPE.AM,
        options: [
            ACCOUNT_MANAGER_REPORT_ID,
            ACCOUNT_MANAGER_VIDEO_REPORT_ID,
            SALES_PERSON_REPORT_ID,
            SALES_PERSON_VIDEO_REPORT_ID,
            SALES_GROUP_REPORT_ID,
            SALES_GROUP_VIDEO_REPORT_ID,
            ACCOUNT_MANAGER_GROUP_REPORT_ID,
            ACCOUNT_MANAGER_GROUP_VIDEO_REPORT_ID,
        ],
    },
    [REPORT_GROUP_TYPE.CAMPAIGN]: {
        label: 'Campaigns',
        id: REPORT_GROUP_TYPE.CAMPAIGN,
        options: [
            CAMPAIGN_REPORT_ID,
            CAMPAIGN_REALTIME_REPORT_ID,
            ADVERTISER_DOMAIN_REPORT_ID,
            ATTRIBUTION_GROUP_REPORT_ID,
        ],
    },
    [REPORT_GROUP_TYPE.AD]: {
        label: 'Ads',
        id: REPORT_GROUP_TYPE.AD,
        options: [CREATIVE_REPORT_ID, DCO_CAMPAIGN_CREATIVE_REPORT_ID, DCO_ITEM_PERFORMANCE_REPORT_ID],
    },
};

export const REPORT_ORDER = [
    TODAY_REPORT_ID,
    PIXEL_BASED_REPORT_ID,
    FIRST_PARTY_REPORT_ID,
    CUSTOM_CONTEXTUAL_REPORT_ID,
    PREDICTIVE_REPORT_ID,
    reportsGroupConfig[REPORT_GROUP_TYPE.TIME],
    ACCOUNT_REPORT_ID,
    ACCOUNT_VIDEO_REPORT_ID,
    CAMPAIGNS_GROUPS_REPORT_ID,
    CAMPAIGNS_GROUPS_REALTIME_REPORT_ID,
    reportsGroupConfig[REPORT_GROUP_TYPE.CAMPAIGN],
    CAMPAIGN_VIDEO_REPORT_ID,
    reportsGroupConfig[REPORT_GROUP_TYPE.AD],
    CREATIVE_VIDEO_REPORT_ID,
    CREATIVE_REALTIME_REPORT_ID,
    QUARTILE_VIDEO_REPORT_ID,
    SITE_REPORT_ID,
    SITE_REALTIME_REPORT_ID,
    SITE_VIDEO_REPORT_ID,
    reportsGroupConfig[REPORT_GROUP_TYPE.GEO],
    reportsGroupConfig[REPORT_GROUP_TYPE.PLATFORM],
    AUDIENCE_REPORT_ID,
    AUDIENCE_BUNDLES_REPORT_ID,
    CONVERSIONS_REPORT_ID,
    CONTEXTUAL_REPORT_ID,
    CONTEXTUAL_VIDEO_REPORT_ID,
    PAYMENTS_REPORT_ID,
    INVOICES_REPORT_ID,
    AUDIENCE_INSIGHTS_REPORT_ID,
    AUDIENCE_BUNDLES_INSIGHTS_REPORT_ID,
    AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID,
    CONTEXTUAL_INSIGHTS_REPORT_ID,
    CAMPAIGN_HISTORY_REPORT_ID,
    reportsGroupConfig[REPORT_GROUP_TYPE.AM],
    FUNNELS_REPORT_ID,
    TEST_EVENTS_REPORT_ID,
    ACTIVE_EVENTS_REPORT_ID,
    COMBINED_AUDIENCES_REPORT_ID,
    PERFORMANCE_RULES_REPORT_ID,
    PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID,
    DYNAMIC_REPORTS_REPORT_ID,
    SCHEDULED_REPORTS_REPORT_ID,
    HIERARCHY_CAMPAIGN_REPORT_ID,
    PUSH_API_REPORT_ID,
    CREATIVE_LIBRARY_REPORT_ID,
    LANDING_PAGES_REPORT_ID,
];
